const creditMarket = [
  {
    name__c: 'Excellent',
    agri_inputs_exp_per_acre: null,
  },
  {
    name__c: 'Good',
    agri_inputs_exp_per_acre: null,
  },
  {
    name__c: 'Satisfactory',
    agri_inputs_exp_per_acre: null,
  },
];

const creditDays = [
  {
    name__c: '30',
    agri_inputs_exp_per_acre: null,
  },
  {
    name__c: '45',
    agri_inputs_exp_per_acre: null,
  },
  {
    name__c: '60',
    agri_inputs_exp_per_acre: null,
  },
  {
    name__c: '75',
    agri_inputs_exp_per_acre: null,
  },
  {
    name__c: '90',
    agri_inputs_exp_per_acre: null,
  },
  {
    name__c: 'Cash',
    agri_inputs_exp_per_acre: null,
  },
];

export { creditMarket, creditDays };
